import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import authService from '../services/authService';
import ErrorBoundary from './common/ErrorBoundary';
import LoadingSpinner from './common/LoadingSpinner';
import Login from './auth/Login';
import Home from './Home';
import Progress from './Progress';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      authLoading: true,
      authInitialized: false,
    };
  }

  componentDidMount() {
    // Subscribe to auth state changes
    this.unsubscribe = authService.subscribe((user) => {
      this.setState({ 
        currentUser: user,
        authLoading: false,
        authInitialized: true
      });
    });

    // Start auth check immediately if Office is ready, otherwise wait
    if (this.props.isOfficeInitialized) {
      this.checkAuthStatus();
    } else {
    }
  }

  componentDidUpdate(prevProps) {
    // Check auth status when Office.js becomes ready
    if (!prevProps.isOfficeInitialized && this.props.isOfficeInitialized) {
      this.checkAuthStatus();
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  async checkAuthStatus() {
    try {
      const user = await authService.checkAuthStatus();
      
      // Update state if not already updated by subscription
      if (!this.state.authInitialized) {
        this.setState({ 
          currentUser: user,
          authLoading: false,
          authInitialized: true
        });
      }
    } catch (error) {
      this.setState({ 
        authLoading: false,
        authInitialized: true,
        currentUser: null
      });
    }
  }

  render() {
    const { title, isOfficeInitialized } = this.props;
    const { currentUser, authLoading, authInitialized } = this.state;


    // Show initial loading while Office.js initializes
    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          message="Plugin loading, please wait..."
        />
      );
    }

    // Show auth loading after Office.js is ready
    if (authLoading || !authInitialized) {
      return (
        <LoadingSpinner label="Checking authentication..." variant="fullscreen" />
      );
    }


    return (
      <ErrorBoundary>
        <div className="App" style={{ backgroundColor: '#f7f7f7' }}>
          <ToastContainer theme="colored" />
          {currentUser ? (
            <Home currentUser={currentUser} />
          ) : (
            <Login />
          )}
        </div>
      </ErrorBoundary>
    );
  }
}

App.propTypes = {
  title: PropTypes.string,
  isOfficeInitialized: PropTypes.bool,
};

export default App;